import React from 'react';

import { Container } from '@/ui';
import { Questionnaire } from '@/features/constructor';
import { useScrollToTop } from '@/hooks';

export const QuestionnairePage = () => {
  useScrollToTop([], { behavior: 'auto' });

  return (
    <Container $paddingBottom={48}>
      <Questionnaire />
    </Container>
  );
};
